<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.code"
            :disabled="!formEditable || id"
            @change="$set(form, 'code', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-color-picker
            :validator="$v.form.color"
            :external-errors="errors['color']"
            :label-form="'Color' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            :value="form.color"
            :disabled="!formEditable"
            @change="$set(form, 'color', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.ordering"
            :external-errors="errors['ordering']"
            :label-form="'Ordinamento' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="number"
            :value="form.ordering"
            :disabled="!formEditable"
            @change="$set(form, 'ordering', $event !== null && $event !== '' ? parseInt($event) : 0)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-boolean
            :external-errors="errors['is_final']"
            :label-form="'Is final' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            :is-required="false"
            :value="form.is_final"
            :disabled="!formEditable"
            @change="$set(form, 'is_final', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as TASK_STATE_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'TaskStateEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'State',
      rolePerm: 'tasks_taskstate_retrieve',
      editRolePerm: 'tasks_taskstate_update'
    }
  },
  computed: {
    ...mapGetters({
      ...TASK_STATE_TYPES.GENERIC.task['task-state'].DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...TASK_STATE_TYPES.GENERIC.task['task-state'].DETAIL.ACTIONS
    }),
    init () {
      this.cleanErrors()
      this.initFields()
      if (this.id) {
        this.retrieve({ id: this.id }).then(() => {
          this.makeFormReadonly()
          this.setForm()
        })
      } else {
        this.$set(this, 'form', { ordering: 0 })
        this.makeFormEditable()
      }
    },
    getFormData () {
      const data = Object.assign({}, this.form)
      if (data.ordering === null || data.ordering === undefined || data.ordering === '') {
        data.ordering = 0
      } else {
        data.ordering = parseInt(data.ordering)
      }
      return data
    }
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      color: {},
      ordering: {}
    }
  }
}
</script>
